<template lang="pug">
div
  b-card
    .container-fluid
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 消耗品オーダー編集/新規作成
          p.text-muted.m-b-30.font-13 SWAN Proサイトの消耗品オーダー内を構成するSECTIONコンテンツの編集画面
          .form-horizontal
            .form-group
              label.col-md-12 品名
              .col-md-12
                input.form-control(name='name', v-model='orderData.name')
            .form-group
              label.col-md-12 品番
              .col-md-12
                input.form-control(name='number', v-model='orderData.number')
            .form-group
              label.col-md-12 品名カテゴリー
              .col-md-12
                select.form-control(name='category', v-model='orderData.category')
                  option(disabled, value='選択してください') ---選択してください---
                  option(v-for='category in categories') {{category}}
            .form-group
              label.col-md-12 関連する製品タイプ
              .col-md-12
                input.form-control(name='related_product', v-model='orderData.related_product')
            .form-group
              label.col-md-12 入数
              .col-md-12
                input.form-control(name='quantity_per_unit', v-model='orderData.quantity_per_unit')
            .form-group
              label.col-md-12 単位
              .col-md-12
                input.form-control(name='unit', v-model='orderData.unit')
            .form-group
              label.col-md-12 最低注文数
              .col-md-12
                input.form-control(name='min_order', v-model='orderData.min_order')
            .form-group
              label.col-md-12 注文単位
              .col-md-12
                input.form-control(name='order_unit', v-model='orderData.order_unit')
            .form-group
              label.col-md-12 価格
              .col-md-12
                input.form-control(name='price', v-model='orderData.price')
            .form-group
              label.col-md-12 納期(納品の目安)
              .col-md-12
                input.form-control(name='delivery_date', v-model='orderData.delivery_date')
            .form-group
              label.col-md-12 画像
              .col-md-12
                input(type='file', name='image', @change="image_upload", ref='product_image')
            button.btn.btn-success.waves-effect.waves-light.m-r-10(@click='register') 登録
  //- .card
  //-   .col-md-12
  //-     .white-box
  //-       h3.box-title.m-b-0 公開設定
  //-       p.text-muted.m-b-30.font-13
  //-       .row
  //-         .col-sm-12.col-xs-12
  //-           form
  //-             .form-group
  //-               label(for='公開状態') 公開状態
  //-               div
  //-                 select.form-control
  //-                   option 未公開（下書き）
  //-                   option 承認依頼
  //-                   option(selected='') 公開
  //-                   option 公開終了
  //-             .form-group
  //-               label(for='承認を依頼したスタッフ') 承認を依頼したスタッフ
  //-               input#exampleInputEmail1.form-control(type='text', placeholder='承認依頼時に指定したスタッフ名を表示')
  //-             .form-group
  //-               label(for='登録日時') 登録日時
  //-               input#publish-date.form-control(type='text', placeholder='YYYY-MM-DD')
  //-             .form-group
  //-               label(for='更新日時') 更新日時
  //-               input#appointed-date.form-control(type='text', placeholder='YYYY-MM-DD')
  //-             .form-group
  //-               label(for='公開予定日時') 公開予定日時
  //-               input#appointed-date.form-control(type='text', placeholder='YYYY-MM-DD')
  //-             .form-group
  //-               label(for='公開終了日時') 公開終了日時
  //-               input#appointed-date.form-control(type='text', placeholder='YYYY-MM-DD')
  //-             .form-group
  //-               label(for='登録ユーザー') 登録ユーザー
  //-               input#appointed-date.form-control(type='text')
  //-             .form-group
  //-               label(for='承認ユーザー') 承認ユーザー
  //-               input#appointed-date.form-control(type='text')
  //-             button.btn.btn-success.waves-effect.waves-light.m-r-10(type='submit') 登録
  //-             button.btn.btn-inverse.waves-effect.waves-light(type='submit') 確認

</template>

<script>
import axios from 'axios'

export default {
  name: 'OrderEdit',
  data () {
    return {
      orderData: {},
      categories: [
        '制御盤',
        'ロボットアーム部',
        '旋回アーム部'
      ],
      imageData: {}
    }
  },
  methods: {
    register: function () {
      let inputData = JSON.stringify(this.orderData)
      console.log(inputData)
      axios({
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/order',
        method: 'POST',
        data: {
          orderData: inputData
        }
      })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    image_upload: function () {
      let files = this.$refs.product_image.files
      this.imageData = files[0]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/order/edit.vue